import application from "../core/chrome/application.js";
import applicationFrame from "../core/chrome/applicationFrame.js";
import errorDocument from "./errorPages/errorDocument.js";
import externalHeaderWidget from "./shared/externalHeaderWidget.js";
import listCompaniesDocument from "./listCompanies/listCompaniesDocument.js";
import loadCompanyDocument from "./listCompanies/loadCompanyDocument.js";
import logoutDocument from "./logout/logoutDocument.js";
import migrateDocument from "./login/migrateDocument.js";
import passwordResetDocument from "./recoverPassword/passwordResetDocument.js";
import recoverPasswordDocument from "./recoverPassword/recoverPasswordDocument.js";
import routeNotFoundDocument from "./shared/routeNotFoundDocument.js";
import session from "../core/session.js";
import signUpRequestDocument from "./signUp/signUpRequestDocument.js";
import theme from "../core/theme.js";
import userService from "../core/services/userService.js";
import viewportWidget from "../core/chrome/viewportWidget.js";

/**
 * Todo: Add JSDoc comment
 */
export default function app() {
	const my = {};

	const that = application({}, my);

	my.routeNotFoundDocument = routeNotFoundDocument();

	my.header = externalHeaderWidget();

	// TODO: temporary
	that.setTheme = function () {
		const themeOptions = {
			colors: {
				"brand-primary": "#565656",
				"brand-primary-dark": "#424242",
				"brand-primary-verydark": "#333333",
			},
			companyName: "",
			brandingName: "",
		};

		theme.setup(themeOptions);
	};

	my.frame = applicationFrame({
		viewport: viewportWidget({
			cssClass: "external-viewport",
		}),
		header: my.header,
	});

	/**
	 * Registers routes and creates menu items using addAction()
	 * Executed once on start-up to initialize the application.
	 */
	that.initialize = function () {
		my.router.addRoute({
			pattern: "login",
			action: () => {
				if (session.wkIdEnabled) {
					my.redirectToLocationPath(userService.getWKLoginUrl());
				} else {
					my.redirectTo("migrate");
				}
			},
		});

		that.addAction({
			name: "migrate",
			pattern: "migrate",
			docFactory: migrateDocument,
		});

		that.addAction({
			name: "logout",
			pattern: "logout",
			action: function (document) {
				document.logout();
			},
			docFactory: logoutDocument,
		});

		that.addAction({
			name: "reset",
			pattern: "reset",
			docFactory: passwordResetDocument,
		});

		that.addAction({
			name: "recover",
			pattern: "recover",
			docFactory: recoverPasswordDocument,
		});

		that.addAction({
			name: "listCompanies",
			pattern: "listCompanies",
			action: function (document) {
				document.listCompanies();
			},
			docFactory: listCompaniesDocument,
		});

		that.addAction({
			name: "loadCompany",
			pattern: "loadCompany/#id",
			action: function (document, id) {
				document.loadCompany(id);
			},
			docFactory: loadCompanyDocument,
		});

		that.addAction({
			name: "error",
			pattern: "error",
			action: function (document, query) {
				document.setError(query);
			},
			docFactory: errorDocument,
		});

		that.addAction({
			name: "signup",
			pattern: "signup",
			action: function (document, query) {
				document.show(query);
			},
			docFactory: signUpRequestDocument,
		});

		my.initializeApplication();
	};

	that.remoteUrl = function (path) {
		// eslint-disable-next-line sonarjs/slow-regex -- don't want to change that now
		const match = window.location.href.match(/(.*\/external\/)([^/]*)\//i);
		const appUrl = match[1];
		const companyId = match[2];

		if (!match || match.length !== 3) {
			return "";
		}
		return appUrl + companyId + path;
	};

	return that;
}
